<template>
  <div class="contentBox">
    <div class="title">All-Star system</div>
    <div class="functionArea">
      <div class="externAppsBox" v-if="!isEmpty(this.externApps)">
        <div
          v-for="(item, index) in externApps"
          :key="index"
          style="cursor: pointer; width: 25px; height: 25px"
          @click="openWindow(item.entry)"
        >
          <template v-if="!isEmpty(item.icon)">
            <img :src="item.icon" alt="" width="25px" height="25px" />
          </template>
          <template v-else>
            <span>{{ item.appName.substring(0, 3) }}</span>
          </template>
        </div>
      </div>
      <el-divider direction="vertical"></el-divider>
      <div class="userOperatesBox">
        <el-dropdown @command="userHandler">
          <div class="userBox">
            <div class="iconBox">
              <img src="../assets/person.png" alt="" />
            </div>
            <div class="usernameBox">
              <span class="userName">{{ this.currentUser.username }}</span>
            </div>
            <div>
              <i class="el-icon-caret-bottom" style="color: #cccccc"></i>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="exit"
                >{{ $t("button.logout") }}<i class="iconfont icon-tuichu"
              /></el-dropdown-item>
            </el-dropdown-menu>
          </div>
        </el-dropdown>
      </div>
      <el-divider direction="vertical"></el-divider>
      <div class="languageChangeBox">
        <el-dropdown @command="languageHandler">
          <div class="languageItemBox">
            <i
              class="iconfont icon-ziranyuyanchuli"
              style="margin-right: 10px"
            ></i>
            <span>{{
              languageList.find((item) => item.code == currentLanguage).name
            }}</span>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="(item, index) in languageList"
              :key="index"
              :command="item.code"
            >
              <div
                style="
                  display: flex;
                  align-items: center;
                  align-content: center;
                  justify-content: flex-start;
                "
              >
                <!-- <svg
                  width="1.5em"
                  height="1.5em"
                  class="icon"
                  aria-hidden="true"
                  style="margin-right: 5px"
                >
                  <use xlink:href="# icon-zhongguoguoqi"></use>
                </svg> -->
                {{ item.name }}
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <template
        v-if="
          !storeHiddenApp
            .map((item) => item.toLowerCase())
            .includes(currentAppName.toLowerCase()) && !isEmpty(this.customers)
        "
      >
        <!-- <template> -->
        <el-divider direction="vertical"></el-divider>
        <div class="selectBox">
          <div>
            <i class="iconfont icon-mendian" style="margin-right: 6px"></i>
          </div>
          <div>
            <el-select
              v-model="currentStore"
              :popper-append-to-body="false"
              popper-class="topHeaderCustomerOption"
              placeholder=""
              @change="terminalChange"
              size="small"
              filterable
              :clearable="canClearStores()"
            >
              <el-option
                v-for="item in currentCustomerStores"
                :key="item.id"
                :label="getLabel(item.terminal, item.terminalName)"
                :value="item.terminal"
              >
              </el-option
            ></el-select>
          </div>
        </div>
      </template>
      <el-divider direction="vertical"></el-divider>
      <div class="selectBox" v-if="!isEmpty(this.customers)">
        <div>
          <i class="iconfont icon-zuzhijiagou" style="margin-right: 6px"></i>
        </div>
        <div>
          <el-select
            v-model="currentCustomer"
            :popper-append-to-body="false"
            popper-class="topHeaderCustomerOption"
            placeholder=" "
            @change="orgChange"
            size="small"
            filterable
          >
            <el-option
              v-for="item in customers"
              :key="item.orgCode"
              :label="getLabel(item.orgCode, item.orgName)"
              :value="item.orgCode"
            >
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isEmpty } from "@/utils/utils";
import { isEqual } from "lodash";
export default {
  props: ["externApps", "languageList", "orgDomains"],
  watch: {
    customers(newVal, oldVal) {
      if (!isEqual(newVal, oldVal)) {
        this.orgTerminalInit();
      }
    },
    // 门店数据变更监听
    globalCurrentStore(newVal) {
      this.currentStore = newVal;
    },
  },
  computed: {
    customers() {
      return this.$actions.getGlobalState("commonData").customer;
    },
    globalCurrentCustomer() {
      return this.$actions.getGlobalState("currentCustomer");
    },
    globalCurrentLanguage() {
      return this.$actions.getGlobalState("currentLanguage");
    },
    currentLanguage() {
      return this.globalCurrentLanguage;
    },
    currentUser() {
      return this.$actions.getGlobalState("currentUser");
    },
    currentAppName() {
      return this.$actions.getGlobalState("currentAppName");
    },
    globalCurrentStore() {
      return this.$actions.getGlobalState("currentStore");
    },
    storeHiddenApp() {
      return window.HS_CONFIG.storeHiddenApp;
    },
    currentCustomerStores() {
      if (this.currentCustomer) {
        if (!isEmpty(this.$actions.getGlobalState("commonData").data)) {
          return (
            this.$actions
              .getGlobalState("commonData")
              .data.find(
                (item) => item.customer.orgCode == this.currentCustomer
              ).terminals ?? []
          );
        }
        return [];
      }
      return [];
    },
  },
  data() {
    return {
      currentCustomer: "",
      currentStore: "",
      // languageList: [],
    };
  },
  created() {
    // this.languageList = window.HS_CONFIG.languageList;
    // this.updateLanguage();
  },
  mounted() {
    console.log(this.$actions.getGlobalState());
    // console.log(
    //   Object.prototype.toString.call(
    //     this.$actions.getGlobalState("currentCustomer")
    //   )
    // );
    // 异步处理门店组织 语言初始化
    // window.setTimeout(() => {
    this.orgTerminalInit();
    // 选择默认语言
    if (this.globalCurrentLanguage) {
      this.$root.$i18n.locale = this.globalCurrentLanguage;
    } else {
      this.$root.$i18n.locale = window.HS_CONFIG.DEFAULT_LANGUAGE;
      this.$actions.setGlobalState({
        currentLanguage: window.HS_CONFIG.DEFAULT_LANGUAGE,
      });
    }
    // }, 0);
  },
  methods: {
    isEmpty,
    orgTerminalInit() {
      //俩全空才选  但凡有一个有值 就不管
      if (
        isEmpty(this.globalCurrentCustomer) &&
        isEmpty(this.globalCurrentStore)
      ) {
        // 如果俩都为空  俩都给选上
        if (!isEmpty(this.customers)) {
          this.currentCustomer = this.customers[0].orgCode;
          this.orgChange(this.currentCustomer);
        }
        if (!isEmpty(this.currentCustomerStores)) {
          this.currentStore = this.currentCustomerStores[0].terminal;
          this.terminalChange(this.currentStore);
        }
      } else {
        this.currentCustomer = this.globalCurrentCustomer;
        this.currentStore = this.globalCurrentStore;
      }
    },
    orgChange(data) {
      this.currentCustomer = data;
      //  有门店默认选中第一个，没有不选
      // this.currentStore = this.currentCustomerStores[0]
      //   ? this.currentCustomerStores[0].terminal
      //   : "";
      this.currentStore = "";
      console.log(this.currentStore);
      window.setTimeout(() => {
        this.$actions.setGlobalState({
          currentCustomer: data,
          currentStore: this.currentStore,
        });
      }, 0);
    },
    terminalChange(data) {
      //门店修改  触发方法
      console.log(data);
      window.setTimeout(() => {
        this.$actions.setGlobalState({
          currentStore: data,
        });
      }, 0);
    },
    languageHandler(data) {
      this.$root.$i18n.locale = data;
      window.setTimeout(() => {
        this.$actions.setGlobalState({
          currentLanguage: data,
        });
      }, 0);
      localStorage.setItem("localeLanguage", data);
    },
    userHandler(data) {
      if (data == "exit") {
        this.$actions.setGlobalState({
          logout: true,
        });
      }
    },
    getLabel(code, name) {
      return name + "(" + code + ")";
    },
    openWindow(entry) {
      let url = entry;
      let accessToken = this.$actions.getGlobalState("accessToken");
      url += "?token=" + accessToken;
      window.open(url);
    },
    canClearStores() {
      console.log(this.orgDomains);
      if (this.orgDomains[0] == "**") {
        //当前超级管理员   都可以关
        return true;
      } else {
        if (!isEmpty(this.orgDomains)) {
          let orgCodes = this.orgDomains.map((item) => item.replace(".**", ""));
          if (orgCodes.includes(this.currentCustomer)) {
            return true;
          }
        }
        return false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.contentBox {
  // background: wheat;
  height: 100%;
  width: 100%;
  border-bottom: 1px solid rgb(217, 222, 226);
  display: flex;
  padding-right: 16px;
  min-width: 700px;
  .title {
    width: 178px;
    min-width: 178px;
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: center;
    border-right: 1px solid rgb(217, 222, 226);
  }
  .functionArea {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    align-content: center;
    flex: 1;
    .userBox {
      display: flex;
      align-items: center;
      align-content: center;
      justify-content: center;
      padding: 7px;
      .iconBox {
        margin-right: 7px;
        display: flex;
        align-items: center;
        align-content: center;
        justify-content: center;
        img {
          height: 22px;
          width: 22px;
        }
      }
      .usernameBox {
        margin-right: 5px;
      }
    }
    .selectBox {
      display: flex;
      align-items: center;
      ::v-deep .el-input__inner {
        text-overflow: ellipsis;
      }
    }
    .externAppsBox {
      margin-right: 7px;
      display: flex;
      align-items: center;
      align-content: center;
    }
  }
  .languageChangeBox {
    margin: 0 10px;
    min-width: 100px;
    .languageItemBox {
      padding: 7px;
      display: flex;
      align-items: center;
      align-content: center;
      justify-content: center;
      .languageIcon {
        margin-right: 7px;
      }
    }
  }
}
</style>
